/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';

import * as AppPropTypes from '../../lib/PropTypes';
import { getImageAtSize } from '../../lib/utils';

import SimonButtonIcon from '../icons/SimonButton';
import Button from './Button';

import styles from '../../../styles/buttons/simon.module.scss';

const propTypes = {
    image: AppPropTypes.image,
    position: PropTypes.string,
    color: PropTypes.string,
    shadowColor: PropTypes.string,
    downColor: PropTypes.string,
    downShadowColor: PropTypes.string,
    down: PropTypes.bool,
    className: PropTypes.string,
    onClick: PropTypes.func,
};

const defaultProps = {
    image: null,
    position: null,
    color: null,
    shadowColor: null,
    downColor: null,
    downShadowColor: null,
    down: false,
    className: null,
    onClick: null,
};

function SimonButton({
    image,
    position,
    color,
    shadowColor,
    downColor,
    downShadowColor,
    down,
    className,
    onClick,
    ...props
}) {
    const { url: imageUrl = null } = getImageAtSize(image, 'small') || {};
    const [isDown, setIsDown] = useState(down);

    useEffect(() => {
        if (down && !isDown) {
            setIsDown(true);
        }
    }, [down]);

    useEffect(() => {
        const timeout = isDown
            ? setTimeout(() => {
                  setIsDown(false);
              }, 500)
            : null;
        return () => {
            if (timeout !== null) {
                clearTimeout(timeout);
            }
        };
    }, [isDown]);
    const onClickButton = useCallback(
        (e) => {
            setIsDown(true);
            if (onClick !== null) {
                onClick(e);
            }
        },
        [onClick],
    );
    return (
        <Button
            className={classNames([
                styles.container,
                {
                    [styles.down]: isDown,
                    [className]: className !== null,
                },
            ])}
            onClick={onClickButton}
            {...props}
        >
            <div className={styles.inner}>
                <SimonButtonIcon
                    down={isDown}
                    position={position}
                    className={styles.icon}
                    color={color}
                    shadowColor={shadowColor}
                    downColor={downColor}
                    downShadowColor={downShadowColor}
                />
                {imageUrl !== null ? (
                    <img src={imageUrl} className={styles.image} alt="Button" />
                ) : null}
            </div>
        </Button>
    );
}

SimonButton.propTypes = propTypes;
SimonButton.defaultProps = defaultProps;

export default SimonButton;
